import './styles.editor.scss';
import { registerBlockType } from '@wordpress/blocks';
import ServerSideRender from '@wordpress/server-side-render';
import { __ } from '@wordpress/i18n';
import { Component, useState, useEffect, Fragment } from '@wordpress/element';
import IconWishListMember from '../icons/icon-wishlist-member';
import {
	Toolbar,
	ToolbarGroup,
	ToolbarItem,
	DropdownMenu,
	PanelBody,
	ToggleControl,
	Button,
	TextControl,
	Disabled,
} from '@wordpress/components';
import { RadioControl } from '@wordpress/components';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import Loading from '../loading';

registerBlockType('wishlist-box-basic-blocks/loginform', {
	title: __('Login Form', 'wishlist-box-basic'),
	description: __('Display Login Form', 'wishlist-box-basic'),
	category: 'wishlist-box-basic-blocks-category',
	keywords: [__('wlm'), __('member'), __('access')],
	icon: IconWishListMember,
	attributes: {
		content: {
			type: 'string',
			default: '[wlm_loginform]',
		},
		cssclasses: {
			type: 'string',
			default: '',
		},
	},
	edit(props) {
		const { attributes, setAttributes } = props;
		const blockProps = useBlockProps();

		const content = attributes.content;
		const cssclasses = attributes.cssclasses;

		const onChangecontent = (value) => {
			setAttributes({ content: value });
		};

		const onChangecssclasses = (value) => {
			setAttributes({ cssclasses: value });
		};

		useEffect(() => {}, [cssclasses, content]);

		return (
			<Fragment>
				<InspectorControls>
					<PanelBody title={__('Options', 'wishlist-member')}>
						<TextControl
							label="CSS Classes"
							value={cssclasses}
							onChange={(value) => onChangecssclasses(value)}
						/>
					</PanelBody>
				</InspectorControls>
				<div {...blockProps}>
					<Disabled>
						<ServerSideRender
							block="wishlist-box-basic-blocks/loginform"
							attributes={attributes}
							LoadingResponsePlaceholder={Loading}
						/>
					</Disabled>
				</div>
			</Fragment>
		);
	},
	save(props) {
		return null;
	},
});
